import { SVGPureIcon } from '@/ui';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';

const FoldSwitch = observer(({
  text = '',
  onClick,
  iconName = '',
  className = '',
  smallClassName = '',
  normalClassName = '',
  textClassName = "",
  iconClassName = "",
  small,
  circle,
  checked = false,
}) => {
  return (
    <Tooltip title={small ? text : ''}>
      <div
        onClick={() => onClick?.()}
        className={[
          'flex items-center h-36px flex-shrink-0',
          'border-1px border-solid border-[rgba(0,0,0,.1)]',
          small ? 'w-32px flex items-center justify-center' : 'px-10px',
          small && !circle ? 'rounded-12px' : 'rounded-8px',
          'text-primary cursor-pointer',
          checked ? 'bg-[#DCEAFE] !text-[#006AFF] border-[#DCEAFE]' : 'text-black bg-gray-nav hover:bg-gray-nav-hover',
          className,
          small ? smallClassName : normalClassName,
        ]}
      >
        <SVGPureIcon name={iconName} className={`size-20px ${small ? '' : 'mr-4px'} ${iconClassName}`} />
        {
          small
          ? null
          : <span className={`text-14px whitespace-nowrap ${textClassName}`}>{text}</span>
        }
      </div>
    </Tooltip>
  );
});

export default FoldSwitch;
